import WidgetHeader from './Header';

export default WidgetHeader;
